import { useState, useCallback } from "react";

export const useLoaderFlag = () => {
  const [showLoader] = useState(() => {
    const hasLoaded = sessionStorage.getItem("hasLoaded");
    return !hasLoaded;
  });

  const [isLoaded, setIsLoaded] = useState(() => {
    return !!sessionStorage.getItem("hasLoaded");
  });

  const markAsLoaded = useCallback(() => {
    sessionStorage.setItem("hasLoaded", "true");
    setIsLoaded(true);
  }, []);

  return { showLoader, markAsLoaded, isLoaded };
};